import {isAreaOrAbove} from "@/utils/identity";

// 侧边栏(Sidebar.vue)与区域级以上首页卡片(SyHome.vue)共用的菜单构建逻辑。
// 历史上这两处各维护一份硬编码 items 和组装代码,长期不同步(典型问题:某菜单只在
// 一处登记,导致另一处出现“空分组”并在取 subs[0] 时崩溃白屏),故统一到这里。
//
// 数据来源:登录后 localStorage.route,即后端 /managers/me 的 Permissions(JSON 字符串)。
// 结构与排序规则见 doc/Menu接口文档.md “权限 JSON 结构与菜单排序”:
//  - Permissions.System 是顶级分组数组(含“首页”),其余 key 是各分组的子菜单数组;
//  - 仅渲染 Show && Selected 的项;
//  - 顶级分组与组内子菜单都按 IntSort 升序,相同时按中文名兜底;
//  - 硬编码 MENU_ITEMS 只提供图标/路由地址/显示名,不决定显隐与顺序。

export const MENU_ITEMS = [
  {
    icon: "el-icon-lx-home",
    index: "/dashboard",
    title: "首页",
  },
  {
    icon: "el-icon-lx-home",
    index: "/dashboard2",
    title: "首页",
  },
  {
    icon: "el-icon-lx-read",
    index: "/bookManagement",
    title: "图书管理",
    subs: [
      {index: "/bookfile", title: "图书档案"},
      {index: "/bookcatalog", title: "图书编目"},
      {index: "/bookputon", title: "图书上架"},
      {index: "/library", title: "书屋管理"},
      {index: "/bookshelf", title: "书架管理"},
      {index: "/classification", title: "分类管理"},
      {index: "/oldbooks", title: "剔旧图书"},
      {index: "/errorManager", title: "报错管理"},
      {index: "/isbnbookinfo", title: "ISBN图书管理"},
    ],
  },
  {
    icon: "el-icon-lx-copy",
    index: "/journal",
    title: "期刊管理",
    subs: [
      {index: "/journalsubscribe", title: "期刊订阅"},
      {index: "/journalregister", title: "期刊登记"},
      {index: "/journaloldcatalog", title: "过刊编目"},
      {index: "/journaltype", title: "期刊类型"},
    ],
  },
  {
    icon: "el-icon-refresh",
    index: "/allcirculation",
    title: "书刊流通",
    subs: [
      {index: "/fastborrowandreturn", title: "快速借还"},
      {index: "/circulation", title: "书刊流通"},
      {index: "/renew", title: "书刊续借"},
      {index: "/survey", title: "流通概况"},
      {index: "/overdue", title: "超期罚款"},
      {index: "/proofreading", title: "图书校对"},
      {index: "/lostandbreaklist", title: "书刊丢失损毁登记", displayTitle: "丢失损毁登记"},
      {index: "/lostandbreakregister", title: "书刊丢失损毁阅览", displayTitle: "丢失损毁记录"},
      {index: "/Appointment", title: "图书预约记录"},
    ],
  },
  {
    icon: "el-icon-lx-friend",
    index: "/reader",
    title: "读者管理",
    subs: [
      {index: "/readerfile", title: "读者档案"},
      {index: "/type", title: "类型管理"},
      {index: "/grade", title: "部门管理"},
      {index: "/class", title: "小组管理"},
    ],
  },
  {
    icon: "el-icon-pie-chart",
    index: "/charts",
    title: "报表统计",
    subs: [
      {index: "/readerlendranking", title: "读者借阅排行"},
      {index: "/booklendranking", title: "图书借阅排行"},
      {index: "/librarychangedmsg", title: "图书位置变更日志", displayTitle: "图书变更日志"},
      {index: "/classifiedstatistics", title: "图书分类统计"},
      {index: "/bookmsgstatistics", title: "图书信息统计"},
      {index: "/schoolranking", title: "区域学校排行"},
      {index: "/workloadstatistics", title: "工作量统计"},
      {index: "/integralstatistics", title: "积分统计"},
      {index: "/bookhousestatistics", title: "书屋统计"},
      {index: "/CirculationStatistics", title: "流通统计"},
      {index: "/newbookbyyear", title: "历年新增图书"},
      {index: "/oldjournalbyyear", title: "过刊统计"},
    ],
  },
  {
    icon: "el-icon-lx-edit",
    index: "/7",
    title: "数据管理",
    subs: [
      {index: "/readerimport", title: "读者信息导入"},
      {index: "/bookimport", title: "图书信息导入"},
      {index: "/circulationimport", title: "借阅信息导入"},
    ],
  },
  {
    icon: "el-icon-lx-settings",
    index: "/donate",
    title: "系统设置",
    subs: [
      {index: "/school", title: "组织管理"},
      {index: "/user", title: "用户管理"},
      {index: "/config", title: "系统设置"},
      {index: "/holiday", title: "假期管理"},
      {index: "/image", title: "封面管理"},
      {index: "/announcement", title: "公告管理"},
      {index: "/publicize", title: "宣传栏管理"},
      {index: "/activity", title: "活动管理"},
      {index: "/database", title: "Z3950管理"},
      {index: "/menumanage", title: "菜单管理"},
    ],
  },
];

// 菜单排序比较器:IntSort 越小越靠前;存量菜单 IntSort 可能同为 0,
// 再按中文名兜底,保证顺序稳定。
function menuComparator(a, b) {
  return (Number(a.IntSort) || 0) - (Number(b.IntSort) || 0) ||
    String(a.StrName || '').localeCompare(String(b.StrName || ''), 'zh');
}

// 仅渲染 Show && Selected 的项;兼容没有 Show 字段的存量权限数据。
function isMenuGranted(node) {
  return !!node && !!node.Selected && node.Show !== false;
}

// 按权限数组构建某分组下的子菜单:硬编码 subs 只提供图标/路由地址,
// 渲染顺序一律以权限数组各项的 IntSort 为准。
function buildSubs(hardGroup, permNodes) {
  const subMap = {};
  (hardGroup.subs || []).forEach(sub => {
    subMap[sub.title] = sub;
  });
  const subs = [];
  (permNodes || []).slice().sort(menuComparator).forEach(node => {
    if (isMenuGranted(node) && subMap[node.StrName] &&
      !subs.some(s => s.title === node.StrName)) {
      subs.push(subMap[node.StrName]);
    }
  });
  return subs;
}

// 根据 Permissions 对象构建首页入口与分组菜单。
// 入参 permissions 可以是对象,也可以是后端原样下发的 JSON 字符串。
// 返回 { home: [首页菜单项], groups: [分组(含 subs)] }
export function buildMenus(permissions) {
  let rou = permissions;
  if (typeof rou === 'string') {
    rou = rou ? JSON.parse(rou) : {};
  }
  rou = rou || {};
  const system = Array.isArray(rou.System) ? rou.System : [];

  // 硬编码 MENU_ITEMS 只提供图标/路由地址,按标题建索引(两个“首页”入口不入分组表)
  const groupMap = {};
  MENU_ITEMS.forEach(g => {
    if (g.title !== '首页' && groupMap[g.title] === undefined) {
      groupMap[g.title] = g;
    }
  });

  const home = [];
  // System 里的“首页”只决定是否出现首页入口;具体落地页按身份区分
  system.some(perm => {
    if (perm.StrName === '首页' && perm.Selected) {
      home.push(isAreaOrAbove() ? MENU_ITEMS[1] : MENU_ITEMS[0]);
      return true;
    }
    return false;
  });

  const makeGroup = hard => ({
    icon: hard.icon,
    index: hard.index,
    title: hard.title,
    subs: buildSubs(hard, rou[hard.title]),
  });

  // 顶级分组一律取 System 数组按 IntSort 排序后渲染,
  // 不能用 Object.keys(Permissions) 的遍历顺序决定分组顺序。
  const groups = [];
  const handledTitles = {};
  system.slice().sort(menuComparator).forEach(perm => {
    if (perm.StrName === '首页') return;
    handledTitles[perm.StrName] = true;
    const hard = groupMap[perm.StrName];
    // Show=false 不渲染;菜单管理里新增但前端尚无对应页面的分组也无法渲染
    if (!hard || perm.Show === false) return;
    const group = makeGroup(hard);
    // 与原逻辑一致:分组下没有任何可见子菜单时不显示该分组
    if (group.subs.length > 0) {
      groups.push(group);
    }
  });

  // 兼容存量数据:权限对象里有、System 数组里没列出的分组,追加到末尾
  MENU_ITEMS.forEach(hard => {
    if (hard.title === '首页' || handledTitles[hard.title] || !rou[hard.title]) return;
    const group = makeGroup(hard);
    if (group.subs.length > 0) {
      groups.push(group);
    }
  });

  return {home, groups};
}
